// extracted by mini-css-extract-plugin
export var divider = "_3n-0";
export var dividerText = "_3n-2";
export var dividerVertical = "_3n-1";